/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'auth-settings';
const componentName = 'auth-mapping-rule-modal';
const prefix = `${moduleName}.${componentName}`;

export const modalTitle = `${prefix}.modalTitle`;
export const sectionTitleMatch = `${prefix}.sectionTitleMatch`;
export const superUserLabel = `${prefix}.superUserLabel`;
export const customMappingLabel = `${prefix}.customMappingLabel`;

export const ENGLISH = {
    [modalTitle]: 'Mapping Rule',
    [sectionTitleMatch]: 'Match',
    [superUserLabel]: 'Super User',
    [customMappingLabel]: 'Custom Mapping',
};
